import { render, staticRenderFns } from "./MyTextArea.vue?vue&type=template&id=1f90aa00&scoped=true&"
import script from "./MyTextArea.vue?vue&type=script&lang=js&"
export * from "./MyTextArea.vue?vue&type=script&lang=js&"
import style0 from "./MyTextArea.vue?vue&type=style&index=0&id=1f90aa00&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f90aa00",
  null
  
)

export default component.exports